<template>

  <div>

      <template v-if="!showModal && activeUser.site.hasDataProcessingConfirmed === false">

        <div style="display: flex; width: 100%; height: 100vh; align-items: center; justify-content: center;">

            <div style="padding: 20px; background-color: #F5F5F5; border-radius: 4px;">
              <h2 style="font-size: 24px; margin-bottom: 12px;">Zustimmung zur Datenschutzvereinbarung</h2>
              <p style="margin-bottom: 12px;">Bitte stimmen Sie zuerst der Datenschutzvereinbarung zu, um die Inhalte einsehen zu können</p>
              <button class="button blue" @click="showModal=true">Öffne Datenschutzvereinbarung</button>
            </div>

        </div>

      </template>

  		<!-- MODAL -->
  		<modal
  			title="Datenschutzvereinbarung"
  			transition="fadeDown"
  			cancel-text="Abbrechen"
  			:show-ok="false"
        :show-close="false"
  			:backdrop-closable="false"
  			:is-show="showModal"
  			class="vcenter"
        width="840"
  			@close="closeModal">

  			<div class="confirmationText">

  				<h2>AUFTRAGSDATENVEREINBARUNG</h2>

  				zwischen<br /><br />

  				(1)	<strong>Apotheke</strong> (im Folgenden „Auftraggeber“)<br />
  				<br />
  				und<br /><br />
  				(2)	<strong>Herba Chemosan Apotheker-AG</strong>, Haidestr. 4, A-1110<br /><br />


  				<div class="headline">1.	Gegenstand der Vereinbarung</div>

  				<ul class="sub">

  					<li>Gegenstand dieses Auftrages ist die Durchführung folgender Aufgaben:</li>
  					<li>Dieser Vertrag konkretisiert die datenschutzrechtlichen Verpflichtungen der Vertragsparteien, die sich aus der bestehenden Zusammenarbeit zwischen Auftraggeber und Auftragnehmer ergeben. Sämtliche in diesem Vertrag beschriebenen Verpflichtungen finden Anwendung auf alle Tätigkeiten, die mit dieser Zusammenarbeit in Zusammenhang stehen und bei denen MitarbeiterInnen des Auftragnehmers oder durch den Auftragnehmer beauftragte Dritte mit personenbezogenen Daten des Auftraggebers in Berührung kommen bzw. kommen können. Dieser Vertrag gilt entsprechend für (Fern-) Prüfung und Wartung automatisierter Verfahren oder von Datenverarbeitungsanlagen, wenn dabei ein Zugriff auf personenbezogene Daten nicht ausgeschlossen werden kann.</li>
  					<li>Der Auftragnehmer verarbeitet unter Anderem personenbezogenen Daten (z.B. Name, E-Mail-Adresse, Adresse etc.), die vom jeweiligen Kundenwunsch abhängen, in der Verantwortung des Auftraggebers erhoben, auf Systemen des Auftragnehmers verarbeitet und für den jeweiligen Zweck und die benötigte Dauer gespeichert werden. Insbesondere sind folgende Tätigkeiten umfasst:<br />

  						<ul>
  							<li>
  								Erstellung von Digitalen Plattformen (Datenverarbeitung, -speicherung)
  							</li>
  							<li>
  								Erstellung von Printpublikationen (Datenverarbeitung, -speicherung)
  							</li>
  							<li>
  								Verarbeitung von digitalen Publikationen (Newsletter)
  							</li>
  						</ul>
  					</li>

  				<li>Der Auftragnehmer erwirbt an den Auftraggeber-Daten keine Rechte.</li>
  				<li>Folgende Datenkategorien werden verarbeitet:<br />
  					<ul>
  						<li>Kundenname</li>
  						<li>Adresse</li>
  						<li>Geschlecht</li>
  						<li>Buchungen, Vertragsdaten</li>
  						<li>Kontaktdaten (eMail-Adresse, Telefonnummer, Ansprechpartner, ...)</li>
  						<li>Verrechnungsdaten</li>
  					</ul>
  				</li>

  				<li>Folgende Kategorien betroffener Personen unterliegen der Verarbeitung:<br />
  					<ul>
  						<li>Kunden</li>
  						<li>Interessenten</li>
  						<li>Beschäftigte</li>
  						<li>Ansprechpartner</li>
  					</ul>
  				</li>
  			</ul>


  			<div class="headline">2.	Dauer der Vereinbarung</div>

  			<ul class="sub">

  				<li>Die Dauer dieses Vertrages richtet sich nach der Laufzeit der Zusammenarbeit zwischen Auftraggeber und Auftragnehmer, sofern sich aus den Bestimmungen dieses Vertrages nicht etwas anderes ergibt.</li>
  				<li>Es ist den Vertragsparteien bewusst, dass ohne Vorliegen eines gültigen Vertrages bei Beendigung des vorliegenden Vertragsverhältnisses keine (weitere) Auftragsverarbeitung durchgeführt werden darf.</li>
  				<li>Das Recht zur fristlosen Kündigung aus wichtigem Grund bleibt unberührt. Kündigungen bedürfen zu ihrer Wirksamkeit der Schriftform.</li>

  			</ul>

  			<div class="headline">3.	Pflichten des Auftragnehmers</div>

  			<ul class="sub">

  				<li>Der Auftragnehmer verpflichtet sich, Daten und Verarbeitungsergebnisse ausschließlich im Rahmen der schriftlichen Aufträge des Auftraggebers zu verarbeiten. Der Auftragnehmer erklärt rechtsverbindlich, dass er alle mit der Datenverarbeitung beauftragten Personen vor Aufnahme der Tätigkeit zur Vertraulichkeit verpflichtet hat oder diese einer Verschwiegenheitsverpflichtung unterliegen. Insbesondere bleibt die Verschwiegenheitsverpflichtung der mit der Datenverarbeitung beauftragten Personen auch nach Beendigung ihrer Tätigkeit und Ausscheiden beim Auftragnehmer aufrecht.
  				</li>
  				<li>Der Auftragnehmer erklärt rechtsverbindlich, dass er alle erforderlichen Maßnahmen zur Gewährleistung der Sicherheit der Verarbeitung nach Art 32 DSGVO ergriffen hat (Einzelheiten sind der Anlage ./1 zu entnehmen).</li>
  				<li>Der Auftragnehmer ergreift die technischen und organisatorischen Maßnahmen, damit der Auftraggeber die Rechte der betroffenen Person nach Kapitel III der DSGVO (Information, Auskunft, Berichtigung und Löschung, Datenübertragbarkeit, Widerspruch, sowie automatisierte Entscheidungsfindung im Einzelfall) innerhalb der gesetzlichen Fristen jederzeit erfüllen kann und überlässt dem Auftraggeber alle dafür notwendigen Informationen. Wird ein entsprechender Antrag an den Auftragnehmer<br /> gerichtet und lässt dieser erkennen, dass der Antragsteller ihn irrtümlich für den Auftraggeber der von ihm betriebenen Datenanwendung hält, hat der Auftragnehmer den Antrag unverzüglich an den Auftraggeber weiterzuleiten und dies dem Antragsteller mitzuteilen.</li>
  				<li>Der Auftragnehmer unterstützt den Auftraggeber bei der Einhaltung der in den Art 32 bis 36 DSGVO genannten Pflichten (Datensicherheitsmaßnahmen, Meldungen von Verletzungen des Schutzes personenbezogener Daten an die Aufsichtsbehörde, Benachrichtigung der von einer Verletzung des Schutzes personenbezogener Daten betroffenen Person, Datenschutz-Folgeabschätzung, vorherige Konsultation).
  				</li>
  				<li>Der Auftragnehmer wird darauf hingewiesen, dass er für die vorliegende Auftragsverarbeitung ein Verarbeitungsverzeichnis nach Art 30 DSGVO zu errichten hat.
  				</li>
  				<li>Dem Auftraggeber wird hinsichtlich der Verarbeitung der von ihm überlassenen Daten das Recht jederzeitiger Einsichtnahme und Kontrolle, sei es auch durch ihn beauftragte Dritte, der Datenverarbeitungseinrichtungen eingeräumt, sofern tatsächliche Anhaltspunkte berechtigte Zweifel am Datenschutz bestehen, wobei Kontrollen tunlichst nur als Stichprobenkontrollen der für die Durchführung der Auftragsverarbeitung relevanten Bereiche durchgeführt werden dürfen und sich der Auftraggeber rechtzeitig im Voraus schriftlich anzumelden hat. Das Gleiche gilt für anlasslose Vor-Ort-Kontrollen. Die Ausübung des Inspektionsrechts darf den Geschäftsbetrieb des Auftragnehmers nicht über Gebühr stören oder missbräuchlich sein.</li>
  				<li>Der Auftraggeber hat dem Auftragnehmer unverzüglich und vollständig zu informieren, wenn er bei der Prüfung Fehler oder Unregelmäßigkeiten bzgl. datenschutzrechtlicher Bestimmungen feststellt.</li>
  				<li>Der Auftragnehmer verpflichtet sich, dem Auftraggeber jene Informationen zur Verfügung zu stellen, die zur Kontrolle der Einhaltung der in dieser Vereinbarung genannten Verpflichtungen notwendig sind.</li>
  				<li>Der Auftragnehmer ist nach Beendigung dieser Vereinbarung verpflichtet, alle Verarbeitungsergebnisse und Unterlagen, die Daten enthalten, dem Auftraggeber zu übergeben. Wenn der Auftragnehmer die Daten in einem speziellen technischen Format verarbeitet, ist er verpflichtet, die Daten nach Beendigung dieser Vereinbarung entweder in diesem Format oder nach Wunsch des Auftraggebers in dem Format, in dem er die Daten vom Auftraggeber erhalten hat oder in einem anderen, gängigen Format herauszugeben, wobei die Kosten der Auftraggeber trägt und der Auftragnehmer eine Vergütung verlangen kann.</li>
  				<li>Der Auftragnehmer hat den Auftraggeber unverzüglich zu informieren, falls er der Ansicht ist, eine Weisung des Auftraggebers verstößt gegen Datenschutzbestimmungen der Union oder der Mitgliedstaaten.</li>
  			</ul>

  			<div class="headline">4.	Ort der Durchführung der Datenverarbeitung</div>

  			<p>
  				Alle Datenverarbeitungstätigkeiten werden ausschließlich innerhalb der EU bzw des EWR durchgeführt. Werden diese auch außerhalb der EU bzw des EWR durchgeführt, so bedarf es der vorherigen schriftlichen Zustimmung durch den Auftraggeber und muss ein angemessenes Datenschutzniveau (z.B. aus einem Angemessenheitsbeschluss der Europäischen Kommission nach Art 45 DSGVO) vorliegen.
  			</p>

  			<div class="headline">5.	Sub-Auftragsverarbeiter</div>

  			<p>
  				Der Auftragnehmer kann Sub-Auftragsverarbeiter hinzuziehen. Der Auftragnehmer schließt die erforderlichen Vereinbarungen im Sinne des Art 28 Abs 4 DSGVO mit dem Sub-Auftragsverarbeiter ab. Dabei ist sicherzustellen, dass der Sub-Auftragsverarbeiter dieselben Verpflichtungen eingeht, die dem Auftragnehmer auf Grund dieser Vereinbarung obliegen. Kommt der Sub-Auftragsverarbeiter seinen Datenschutzpflichten nicht nach, so haftet der Auftragnehmer gegenüber dem Auftraggeber für die Einhaltung der Pflichten des Sub-Auftragsverarbeiters.
  			</p>

  			<div class="headline">6.	Sonstige Bestimmungen</div>

  			<ul class="sub">
  				<li>Änderungen und Ergänzungen dieses Vertrages sowie dieser Klausel bedürfen der Schriftform.</li>
  				<li>Sollten einzelne Bestimmungen dieses Vertrages ganz oder teilweise unwirksam sein, so bleibt die Rechtswirksamkeit dieses Vertrages im Übrigen unberührt. Die Vertragspartner sind verpflichtet, anstelle der unwirksamen Bestimmung diejenige Regelung zu treffen, die dem wirtschaftlichen und rechtlichen Gehalt der unwirksamen Bestimmung am nächsten kommt, sofern sie diesen Punkt bedacht hätten und die sie in Kenntnis der Unwirksamkeit nach Treu und Glauben zulässigerweise getroffen hätten.</li>
  				<li>Es gilt österreichisches Recht. Gerichtsstand für alle Streitigkeiten aus diesem Vertrag ist das Handelsgericht Wien.</li>
  			</ul>

  			</div>

  			<div slot="footer">
  				<!-- <span class="button" @click="closeModal">abbrechen</span> -->
  				<span :class="['button is-success', { 'is-loading': isSaving }]" @click="confirm">Bestätigen</span>
  			</div>

  		</modal>

  </div>

</template>


<script>


export default {

  data() {
    return {
      showModal: false,
      isSaving: false,
    }
  },

  created() {

  },

  mounted() {
    this.showModal = true;
  },

  methods: {

    closeModal() {
      this.showModal = !this.showModal;
    },

    confirm() {

      this.isSaving = true;

      let user = this.activeUser;
      user.site.hasDataProcessingConfirmed = true;

      this.axios.put(this.$config.api + 'site/'+this.activeUser.site.id, user.site)
        .then((res) => {
          this.$store.commit('setUser', user );
        })
        .finally(() => {
          this.isSaving = false;
          this.showModal = false;
        })

      /*
      setTimeout(() => {

        this.$store.commit('setUser', user );
        this.$forceUpdate();
        this.isSaving = false;
        this.showModal = false;

        console.log(this.activeUser.site.hasDataProcessingConfirmed);
      }, 1500);

      */



    }

  }

}
</script>


<style lang="scss" scoped>

  ::v-deep.button {
    width: auto !important;
    height: auto;
    padding: 10px 50px !important;
  }

  ::v-deep.modal {

    .modal-card {
      width: 85%;
      max-width: 1024px;
    }

    .modal-card-body {
      max-height: 80vh;
      overflow-y: scroll;

      .headline {
        padding: 0 0 14px 0;
        text-transform: uppercase;
        font-size: 16px;
      }

      p {
        padding: initial;
        margin: 0 0 1.3em 0;
      }
      ul {
        list-style: initial;
        padding: 0 0 0 32px;
        margin: 0 0 1.3em 0 !important;

        &.sub {
          list-style: lower-alpha !important;
        }

        li {
          margin: 0 0 2px 0;
          padding: 0 0 0 12px;
        }
      }
    }
  }



</style>
